import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 group">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-play-circle-fill text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">
                蘑菇视频
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              海量高清视频在线观看平台，覆盖纪录片、科技、影视、教育、美食等多个领域。免费、高清、流畅，随时随地畅享精彩内容。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-background-50 hover:bg-primary-600 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-background-50 hover:bg-primary-600 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:text-background-50 hover:bg-primary-600 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <a href="#footer-categories" className="hover:text-primary-400 transition-colors">热门分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-50 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <a href="#footer-quick" className="hover:text-primary-400 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-background-50 transition-colors">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-50 transition-colors">关于我们</Link></li>
              <li><Link to="/category/documentary" className="text-sm text-background-400 hover:text-background-50 transition-colors">纪录片</Link></li>
              <li><Link to="/category/technology" className="text-sm text-background-400 hover:text-background-50 transition-colors">科技</Link></li>
              <li><Link to="/category/education" className="text-sm text-background-400 hover:text-background-50 transition-colors">教育</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              <a href="#footer-contact" className="hover:text-primary-400 transition-colors">联系方式</a>
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-mail-line text-xs"></i>
                </div>
                <span>contact@moguvideo.cn</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-phone-line text-xs"></i>
                </div>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-xs"></i>
                </div>
                <span>北京市海淀区中关村科技园区创新大厦18层</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 蘑菇视频在线观看 moguvideo.cn - 海量高清视频免费看
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-background-300 transition-colors">用户协议</a>
            <a href="#" className="hover:text-background-300 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-background-300 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}